import { companyApis } from '../balanceApi';

export function getHooksForCompany(company) {
    const api = companyApis[company];
    if (!api) return null;

    return {
        useFetchBalanceQuery: api.endpoints.fetchBalance.useQuery,
        useFetchBudgetQuery: api.endpoints.fetchBudget.useQuery,
        useFetchLastYearBalanceQuery: api.endpoints.fetchBalance.useQuery,
        useFetchAppointmentsQuery: api.endpoints.fetchAppointments.useQuery,
        useFetchAppointmentStatisticsQuery: api.endpoints.fetchAppointmentStatistics.useQuery,
    };
}

  
